import * as React from 'react';
import {Route, Link} from 'react-router-dom';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';
import {WarningIcon} from '../icon/svg/warning-icon';
import {NewBadge} from '../new-badge/new-badge';

import styles from './sidebar-nav.module.css';

type LinkId = string;

export type LinkConfig = {
    id: LinkId;
    linkText: string;
    to: string;
    path?: string;
    exact?: boolean;
    icon?: React.ComponentType<any> | string;
    warningTooltip?: string;
    requiresUpgrade?: boolean;
    hideUpgradeArrow?: boolean; // If the whole section requires upgrade, we don't want to show the arrow for each link,
    isHidden?: boolean;
    isNew?: boolean;
    count?: number | null | undefined | string;
    activeMatch?: RegExp; // Matches against pathname,
    searchMatch?: RegExp; // Matches against search params,
    onClick?: (e: React.SyntheticEvent<any>) => any; // If provided, will override the `to` prop,
    tags?: string[];
};

type Props = LinkConfig;

export const LinkItem = (props: Props) => {
    const Icon = props.icon;

    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, [props.warningTooltip]);

    return (
        <Route exact={props.exact} path={props.path ? props.path : props.to}>
            {({match}) => {
                let isActive = match;
                if (props.activeMatch && props.searchMatch) {
                    // @ts-expect-error
                    isActive =
                        props.activeMatch.test(location.pathname) &&
                        props.searchMatch.test(location.search);
                } else if (props.activeMatch) {
                    // @ts-expect-error
                    isActive = props.activeMatch.test(location.pathname);
                }

                return (
                    <li
                        id={`linkItem-${props.id}`}
                        className={isActive ? styles['link--active'] : styles.link}
                    >
                        {props.requiresUpgrade ? (
                            <div className={styles['requires-upgrade-link']}>
                                {/* @ts-expect-error */}
                                <Link
                                    to={props.onClick ? '#' : props.to}
                                    onClick={handleClick(props.onClick)}
                                >
                                    {Icon ? <Icon className={styles.icon} /> : undefined}
                                    <span className={styles['link-text']}>{props.linkText}</span>
                                    {!props.hideUpgradeArrow && (
                                        <div className={styles['upgrade-arrow-container']}>
                                            <UpgradeArrowIcon
                                                className={styles['upgrade-arrow']}
                                                size={16}
                                            />
                                        </div>
                                    )}
                                </Link>
                            </div>
                        ) : (
                            // @ts-expect-error
                            <Link
                                to={props.onClick ? '#' : props.to}
                                onClick={handleClick(props.onClick)}
                            >
                                {Icon ? <Icon className={styles.icon} /> : undefined}
                                <span className={styles['link-text']}>{props.linkText}</span>
                                {props.warningTooltip && !props.requiresUpgrade ? (
                                    <div className={styles['warning-icon-container']}>
                                        <WarningIcon
                                            // @ts-expect-error
                                            color={colors.yellow}
                                            size={15}
                                            data-tip={props.warningTooltip}
                                        />
                                    </div>
                                ) : undefined}
                                {props.isNew ? <NewBadge /> : undefined}
                                {props.count !== undefined ? (
                                    <div className={styles['count-container']}>{props.count}</div>
                                ) : undefined}
                            </Link>
                        )}
                    </li>
                );
            }}
        </Route>
    );
};

function handleClick(onClick?: (e: React.SyntheticEvent<any>) => void) {
    return (e: React.SyntheticEvent<any>) => {
        // Always reset scroll to the top of the window when clicking sidebar nav items
        window.scrollTo(0, 0);

        if (typeof onClick === 'function') {
            onClick(e);
        }
    };
}
